import React from 'react';
import CheckboxSelectorAlpha from './CheckboxSelector.alpha';
import CheckboxSelectorLegacy from './CheckboxSelector.legacy';

interface CheckboxTypes {
  value: string;
  checked: boolean;
  onChange: (option: string, newChecked: boolean) => void;
  label: string | React.ReactNode;
  ariaLabel: string;
  inputName: string;
  disabled?: boolean;
  hint?: string;
  filterType?: string;
}

const CheckboxSelector: React.FC<CheckboxTypes> = (props) => {
  const isAlpha = !process.env.IS_LEGACY;
  const Component = isAlpha ? CheckboxSelectorAlpha : CheckboxSelectorLegacy;
  return <Component {...props} />;
};

export default CheckboxSelector;
